<div class="command-content">
  <mat-chip-set>
    @if (!isExpanded && combinedStrings()?.length > 1) {
      <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
        <div class="command-content__showmore">
          <mat-chip (click)="$event.stopPropagation()">{{ combinedStrings()?.[0] }}</mat-chip>
          <button
            mat-flat-button
            class="command-content__chip-showmore"
            [matTooltip]="showMoreTooltip()"
            (click)="onClickShowMore($event)"
          >
            +{{ combinedStrings()?.length - 1 }}
          </button>
        </div>
      </div>
    } @else {
      @for (combinedString of combinedStrings(); track combinedString) {
        <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
          <mat-chip (click)="$event.stopPropagation()">{{ combinedString }}</mat-chip>
        </div>
      }
      @if (combinedStrings()?.length > 1) {
        <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
          <button
            mat-flat-button
            class="command-content__chip-showmore"
            [matTooltip]="showMoreTooltip()"
            (click)="onClickShowLess($event)"
          >
            <mat-icon>arrow_left</mat-icon>
          </button>
        </div>
      }
    }
  </mat-chip-set>
</div>
